// The rulesets a lobby host may pick online. Each id is a shipped preset the
// match-server resolves to a ruleset (apps/match-server/src/presets.ts); ranked
// accepts `standard` only. Explorer/Apprentice are single-player on-ramps, and
// Legends (Champions) and Royal Houses stay Custom-only until the Champion soak
// and a human playtest (ROADMAP 7.17).
export const LOBBY_PRESETS: readonly { readonly id: string; readonly label: string }[] = [
  { id: 'standard', label: 'Standard' },
  { id: 'strategist', label: 'Strategist' },
  { id: 'grand', label: 'Grand' },
  { id: 'highlands', label: 'Highlands' },
  { id: 'seafarers', label: 'Seafarers' },
];
